module.exports = __webpack_public_path__ + "static/25-00089775d834d955ab40777bd3b5c1f4.jpg";